<div class="buttons-container" *ngIf="showSaveButton && !loading">
  <u-button
    *ngIf="!isNewCollection"
    class="no-border-button reset-button"
    [label]="collectionContent.reset"
    type="secondary"
    (onClick)="resetFilterBox()"
    [styles]="{ width: '72px', height: '28px' }"
  ></u-button>
  <ng-container *ngIf="collection?.kind === 'Wiki' || isNewCollection; else duplication">
    <u-button
      *ngIf="canEdit"
      [label]="collectionContent.save"
      type="primary"
      (onClick)="save()"
      [styles]="{ width: 'max-content', height: '28px' }"
    ></u-button>
  </ng-container>
  <ng-template #duplication>
    <split-button-wrapper
      *ngIf="canEdit"
      [label]="collectionContent.save"
      [items]="splitButtonItems"
      (invoke)="onSplitButtonContextMenuCommand($event)"
      [styles]="{ width: 'max-content', height: '28px' }"
      elementSize="small28"
      class="split-button"
      (onClick)="save()"
    ></split-button-wrapper>
    <u-button
      *ngIf="!canEdit"
      [label]="collectionContent.saveAsNew"
      type="primary"
      (onClick)="saveAs()"
      [styles]="{ width: 'max-content', height: '28px' }"
    ></u-button>
  </ng-template>
</div>
